import { render, staticRenderFns } from "./ReasonReject.vue?vue&type=template&id=51e8b6cc&"
import script from "./ReasonReject.vue?vue&type=script&lang=js&"
export * from "./ReasonReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports